import React, { Component, useEffect } from 'react';
import axios from 'axios';

import { ConvToString, ConvToInt, ConvToBool } from 'Common/utilsEx.js';

export default class MFAForm extends Component {
    constructor(props) {
        super(props);

        this.state =
        {
            qrCode: '',
            qrError: '',
            mfaInfo: '',
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {

    }
	componentDidMount() {
		this.getQRCode();

  }


    render() {
		let skipMFALink = "";
		if(this.props.Screen.daysToFinish>=0)
			skipMFALink = <a href="#" onClick={() => this.props.onSkip()}>Skip for now</a>;
		else
			skipMFALink = <a href="#" disabled>Skip for now</a>;
		

		return (
			<div className="form2">
				<form onSubmit={(e) => e.preventDefault()}
					onKeyPress={(event) => this.onProceedFormKeyPress(event)} method="post">
					<div style={{ color: '#188DB2', marginBottom : '18px',fontSize: '1.5em' }}>Hi {this.props.UserDetails.userName},</div>
					
					<span>Please setup an Authenticator app for 2-Factor authentication like Google Authenticator or Microsoft Authenticator on your phone. 
					Scan the QR code given below in the app to register.</span>
					<div className="relPos" style={{display:"flex","justifyContent":"center"}}>
						{this.showQRCode()}
						{this.showDaysToFinish()}
					</div>
					
					<div className="row-1">
						{this.RegisterMFAButton()}<div style={{float: "right"}}>{skipMFALink}</div>
					</div>
				</form>
			</div>
		)
    }
	showDaysToFinish()
	{
		if(this.props.Screen.daysToFinish>=0)
		return (<div className="dayCount">
			<span className="DayInfo">{this.props.Screen.daysToFinish}</span><br/>
			<span className="daysLeft">days left</span>
		</div>);
		
		return "";
	}
	showQRCode()
	{
		if(this.state.qrError.length>0)
		return (<span>{this.state.qrError}</span>);
		else
		return (<img src={this.state.qrCode} className="mfaSetup"/>);
	}
    RegisterMFAButton()
	{
		 return (<button
                    ref='registerMFAButton'
                    className="form1-bu w50"
                    onClick={() => this.onRegisterMFAButtonClick()}
                >Next</button>);
	}
	getQRCode()
	{
		fetch(window.baseUrl+'Login/qrMFA',{
			method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: '',
		})
		 .then(response => {
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				return response.json()
			})
		.then(respdata => {
			if (respdata && respdata.status) {
				this.setState({qrCode:respdata.result,mfaInfo:respdata.info});
				this.props.Screen.mfaInfo=respdata.info;
			}
		})
		
		.catch((error) => {
				this.props.Screen.mfaInfo='';
                console.error('Error:', error);
                if (error instanceof SyntaxError && error.message.includes('JSON')) {
                    this.setState({qrError:'The server returned an empty or invalid response. Please try again.'});
                  } else if (error.message === 'Network response was not ok' || error instanceof TypeError) {
                    this.setState({qrError: 'There was a problem connecting with the server. Please check your network connection and try again.'});
                  } else {
                    this.setState({qrError: 'An unexpected error occurred. Please try again.'});
                }
            });
	}

    onProceedFormKeyPress(event) {

        if (event.charCode == 13) {//Enter key pressed
            event.preventDefault();
            this.onRegisterMFAButtonClick(false);
        }

    }
    onRegisterMFAButtonClick() {
        this.setState({ enableLoader: true  }, () => {
            this.RegisterMFA();
        });
    }
    getParams() {
        let htParams = {};
        htParams['UserID'] = this.state.UserIdTxt;

        return htParams;
    }

    RegisterMFA() 
	{
		this.props.onNext();
    }
    ShowLoadingScreen() {
        window.location = window.baseUrl + 'Login/Loading';
    }
    ProceedResponse(loginInfo) {
        if (loginInfo != null) {
				if (this.props.Parent.refs.ProceedForm)
                this.props.Parent.refs.ProceedForm.showLoginDetailsWindow(loginInfo, () => { this.props.Parent.forceUpdate(); })			
        }

    }
	show(loginInfo, cb)
	{
        //this.props.Screen.showLoginDiv = false;//Hides login panel
        //this.props.Screen.showMFA = true;//Shows MFA panel
		debugger;
		this.getQRCode();
		if(cb)
		cb();
	}
}
